import { IFolder, IZoomToBoundsId } from './Interfaces';

export interface IFolderState {
    selectedFolderIds: Array<string>;
    folders: Array<IFolder> | null;
    visibleFolders: Array<IFolder>;
    folderFields: Array<string>;
    zoomToFolderBoundsId: IZoomToBoundsId;
    selectedFolderId: string | null;
    refreshIndex: number;
    expandedFolderIds: Array<string>;
    isLoadingFolders: boolean;
}

export const initialFolderState: IFolderState = {
    folders: null,
    visibleFolders: [],
    folderFields: [],
    zoomToFolderBoundsId: null,
    selectedFolderId: null,
    refreshIndex: 0,
    selectedFolderIds: [],
    expandedFolderIds: [],
    isLoadingFolders: false,
};
